export default __webpack_public_path__ + "static/media/1804.7070cbc9.png";